<template>
  <side :nav="nav"></side>
</template>

<script>
import side from "../side";
import role from "../../mixins/role";
export default {
  data() {
    return {
      nav: [],
    };
  },
  components: { side },
  mixins: [role],
  mounted() {
    // if(this.userModule.role=="AreaManager"){
    //   var nl = [
    //     { name: "角色管理", url: "manageRole" },
    //     { name: "资源类别管理", url: "manageCategory" },
    //     { name: "宣传图管理", url: "manageBanner" },
    //     { name: "文印管理", url: "managePrinting" },
    //     // { name: "审核管理", url: "manageExamine" },
    //     // { name: "打印员管理", url: "managePrinter" },
    //     { name: "白名单设置", url: "whiteList" }
    //     ]
    //     this.nav = nl;
    //     this.$router.push({name:'manageRole'});
    // }else if(this.userModule.role=="SchoolManager"){
    //   var nl = [
    //     { name: "打印员管理", url: "managePrinter" }
    //     ]
    //     this.nav = nl;
    //     this.$router.push({name:'managePrinter'});
    // }else if(this.userModule.role=="Auditor"){
    //   var nl = [
    //     { name: "审核管理", url: "manageExamine" }
    //     ]
    //     this.nav = nl;
    //     this.$router.push({name:'manageExamine'});
    // }else{
    //   this.nav = [];
    //   this.$router.push({name:'IndexPage'});
    //   return;
    // }
  },
  methods: {
    init() {
      let that = this;
      that.userModule.roles.forEach((event) => {
        if (
          event.roleCode == "SchoolManager" ||
          event.roleCode == "BusinessManager"
        ) {
          var nl = [
            { name: "打印员管理", url: "managePrinter" },
            { name: "角色管理", url: "manageRole" },
            // { name: "审核管理", url: "manageExamine" },
          ];
          that.nav = that.nav.concat(nl);
        }
      });
      // 局应用管理员 admin 校 BusinessManager
      that.userModule.roles.forEach((event) => {
        if (event.roleCode == "AreaManager") {
          var nl = [
            { name: "角色管理", url: "manageRole" },
            { name: "资源类别管理", url: "manageCategory" },
            { name: "宣传图管理", url: "manageBanner" },
            // { name: "文印管理", url: "managePrinting" },
            { name: "白名单设置", url: "whiteList" },
            { name: "同步管理", url: "manageSync" },
            // { name: "审核管理", url: "manageExamine" }
          ];
          that.nav = that.nav.concat(nl);
        }
        // if (event.roleCode == "Auditor") {
        //   var nl = [{ name: "审核管理", url: "manageExamine" }];
        //   that.nav = that.nav.concat(nl);
        //   // this.$router.push({ name: "manageExamine" });
        // }
        var obj = {};
        that.nav = that.nav.reduce(function (data, item) {
          obj[item.url] ? "" : (obj[item.url] = true && data.push(item));
          return data;
        }, []);
      });
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/page/manage/manage.vue